import $ from 'jquery';

export default class ContactRequestFormHandler {
  constructor(config) {
    this._container = config.container;
    this._init();
  }

  _getButtonTextSize(button) {
    var span = $('<span></span>');
    span.css('font-family', button.css('font-family'));
    span.css('font-size', button.css('font-size'));
    span.css('text-transform', button.css('text-transform'));
    span.html(button.val());

    $('body').append(span);
    var width = span.width();
    span.remove();

    return width;
  }

  _init() {
    var contactRequestForm = this._container.find('form');

    var _self = this;

    var wrapperForm = this._container.find('.wrapper-form');
    var wrapperMessage = this._container.find('.wrapper-message');

    var submitButton = contactRequestForm.find('input[type="submit"]');
    var checkIcon = contactRequestForm.find('.check-icon');
    var loadingIcon = contactRequestForm.find('.loading-icon');
    var showGenericError = function() {
      loadingIcon.removeClass('active');
      submitButton.prop('disabled', false);
    };

    var handleResponse = function(response) {
      if (response && response['status'] === 'success') {
        submitButton.addClass('btn_success');
        submitButton.prop('disabled', true);
        submitButton.css('cursor', 'default');

        loadingIcon.removeClass('active');
        checkIcon.addClass('active');

        setTimeout(function() {
          checkIcon.removeClass('active');

          wrapperForm.hide();
          wrapperMessage.find('.message-success').html(response['message']);
          wrapperMessage.show();

          if (typeof window.dataLayer === 'undefined') { window.dataLayer = []; }
          window.dataLayer.push({'event':  'contact_request_form_filled_out'});
        }, 1000);
      } else if (response && response['status'] === 'validation') {
        $.each(response.errors, function(index, value) {
          contactRequestForm.find('#inp-'+index).parent().addClass('error');
          contactRequestForm.find('#inp-'+index).before('<div class="input__error">' + value + '</div>');
          submitButton.prop('disabled', false);
        });

        var altchaWidget = contactRequestForm.find('altcha-widget').get(0);
        if (altchaWidget && typeof altchaWidget.reset === 'function') {
          altchaWidget.reset();
        }

        loadingIcon.removeClass('active');
      } else if (response && response['status'] === 'error') {
        submitButton.prop('disabled', false);
        loadingIcon.removeClass('active');
        if (response['message']) {
          wrapperMessage.find('.message-success').html(response['message']);
          wrapperMessage.show();
        }
      } else {
        showGenericError();
      }
    };

    contactRequestForm.on('submit', function(event) {
      event.preventDefault();

      submitButton.prop('disabled', true);
      contactRequestForm.find('.error').removeClass('error');
      contactRequestForm.find('.input__error').remove();
      contactRequestForm.find('.icon').removeClass('active');

      var marginLeft = (submitButton.outerWidth() + _self._getButtonTextSize(submitButton)) / 2;
      checkIcon.css('margin-left', marginLeft);
      loadingIcon.css('margin-left', marginLeft);
      loadingIcon.addClass('active');

      var utmSource = window.getCookie('utm_source');
      if (utmSource !== 'null') {
        contactRequestForm.find('#utm-source').val(utmSource);
      }
      var utmMedium = window.getCookie('utm_medium');
      if (utmMedium !== 'null') {
        contactRequestForm.find('#utm-medium').val(utmMedium);
      }
      var utmCampaign = window.getCookie('utm_campaign');
      if (utmCampaign !== 'null') {
        contactRequestForm.find('#utm-campaign').val(utmCampaign);
      }
      var utmTerm = window.getCookie('utm_term');
      if (utmTerm !== 'null') {
        contactRequestForm.find('#utm-term').val(utmTerm);
      }
      var utmContent = window.getCookie('utm_content');
      if (utmContent !== 'null') {
        contactRequestForm.find('#utm-content').val(utmContent);
      }

      var canonicalUrl = $("link[rel='canonical']").attr('href');
      if (canonicalUrl) {
        contactRequestForm.find('#landingpage').val(canonicalUrl);
      }

      $.ajax({
        url: contactRequestForm.attr('action'),
        type: 'POST',
        data: contactRequestForm.serialize(),
        dataType: 'json',
        success: function(response) {
          handleResponse(response);
        },
        error: function() {
          showGenericError();
        },
      });
    });
  }
}
